var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"item-text":"_id","item-value":"_id","error":_vm.errorLoadingSchemas,"error-messages":_vm.errorLoadingSchemas ? 'Cannot find items of type: ' + _vm.type : '',"loading":_vm.loadingSchemas}})
}
var staticRenderFns = []

export { render, staticRenderFns }